export enum Currency {
  NIS = 'NIS'
}
